import { PropsWithChildren, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { KizenTypography } from '__app/typography';
import { HistoryButtonsWrapper } from './styles';
import { ExecutionHistoryContext } from 'ts-components/AutomationEngine/ExecutionHistory/context';
import { useAutomationsDispatch } from '../store/react';
import { actions } from '../store';
import { setSearchParams } from '__hooks/useSearchParam';
import { useHistory } from 'react-router-dom';
import { Button } from '@kizen/kds/Button';
import { TextEllipsisWithTooltip } from '__components/Kizen/Table';

export const HistoryButtons = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation();
  const history = useHistory();
  const {
    selectedExecution,
    executionWarning,
    orderedExecutionHistory,
    setHistoryId,
    setSelectedExecution,
    isHistoryFetching,
  } = useContext(ExecutionHistoryContext);
  const dispatch = useAutomationsDispatch();
  const triggerTime =
    selectedExecution?.start_time || orderedExecutionHistory?.[0]?.created;

  return (
    <HistoryButtonsWrapper data-qa="history-buttons-wrapper">
      <div className="title info">
        <KizenTypography
          className="info"
          as="div"
          size="button"
          data-qa="history-trigger-message"
        >
          {triggerTime
            ? t('Triggered at {{triggered}}', {
                triggered: format(triggerTime, 'MM/dd/yyyy HH:mm:ss'),
              })
            : null}
        </KizenTypography>
        <div className="close">
          <Button
            data-qa="history-close-button"
            variant="text"
            rightIcon="action-close"
            color="secondary"
            onClick={() => {
              dispatch(actions.setHistoryId(null));
              setHistoryId(null);
              setSelectedExecution(null);
              setSearchParams(
                history,
                { history: null },
                { method: 'replace' }
              );
            }}
            size="small"
            qa={{
              action: 'history-close-button',
              type: 'icon-button',
            }}
          />
        </div>
      </div>
      {!isHistoryFetching && executionWarning ? (
        <TextEllipsisWithTooltip
          data-qa="history-trigger-warning"
          as="div"
          size="button"
          color="var(--color-feedback-error)"
        >
          {executionWarning}
        </TextEllipsisWithTooltip>
      ) : (
        <div data-qa="history-trigger-warning" className="title info"></div>
      )}
      <div className="buttons">{children}</div>
    </HistoryButtonsWrapper>
  );
};
